<template>
  <div class="is-chars">
    <!-- input type="text" class="input" ref="input" / -->
    <!-- div contenteditable="true" class="input" ref="input"></div -->
    <div class="keyboard">
      <button class="key" @click="onCharacterClicked" data-char="á"></button>
      <button class="key" @click="onCharacterClicked" data-char="é"></button
      ><button class="key" @click="onCharacterClicked" data-char="í"></button>
      <button class="key" @click="onCharacterClicked" data-char="ó"></button
      ><button class="key" @click="onCharacterClicked" data-char="ú"></button>
      <button class="key" @click="onCharacterClicked" data-char="ý"></button
      ><button class="key" @click="onCharacterClicked" data-char="þ"></button>
      <button class="key" @click="onCharacterClicked" data-char="ð"></button
      ><button class="key" @click="onCharacterClicked" data-char="æ"></button>
      <button class="key" @click="onCharacterClicked" data-char="ö"></button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    clearSelection() {
      if (window.getSelection) {
        if (window.getSelection().empty) {
          // Chrome
          window.getSelection().empty();
        } else if (window.getSelection().removeAllRanges) {
          // Firefox
          window.getSelection().removeAllRanges();
        }
      } else if (document.selection) {
        // IE?
        document.selection.empty();
      }
    },
    saveSelection() {
      if (window.getSelection) {
        let sel = window.getSelection();
        if (sel.getRangeAt && sel.rangeCount) {
          return sel.getRangeAt(0);
        }
      } else if (document.selection && document.selection.createRange) {
        return document.selection.createRange();
      }
      return null;
    },

    restoreSelection(range) {
      if (range) {
        if (window.getSelection) {
          let sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
        } else if (document.selection && range.select) {
          range.select();
        }
      } else {
        this.clearSelection();
      }
    },
    onCharacterClicked(e) {
      const ch = e.srcElement.getAttribute("data-char");
      this.$emit("is-char-event", ch);

      /*
      let input = this.$refs.input;

      //// input type="text"
      // if (document.selection) {
      //   input.focus();
      //   var sel = document.selection.createRange();
      //   sel.text = ch;
      //   input.focus();
      // } else if (input.selectionStart || input.selectionStart === 0) {
      //   var startPos = input.selectionStart;
      //   var endPos = input.selectionEnd;
      //   input.value =
      //     input.value.substring(0, startPos) +
      //     ch +
      //     input.value.substring(endPos, input.value.length);
      //   input.focus();
      //   input.selectionStart = startPos + ch.length;
      //   input.selectionEnd = startPos + ch.length;
      // } else {
      //   input.value += ch;
      //   input.focus();
      // }

      //// contenteditable="true"
      input.focus();
      if (window.getSelection) {
        let sel = window.getSelection();
        if (sel.getRangeAt && sel.rangeCount) {
          let range = sel.getRangeAt(0);
          range.deleteContents();
          let node = document.createTextNode(ch);
          range.insertNode(node);

          let newRange = document.createRange();
          newRange.setStart(node, 1)
          newRange.setEnd(node, 1)
          sel.removeAllRanges();
          sel.addRange(newRange);
        }
      } else if (document.selection && document.selection.createRange) {
        document.selection.createRange().text = ch;
      }
      */
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/scss/components-shared.scss";

.is-chars {
  padding-top: 2rem;
}
.keyboard button.key {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  margin: auto 0.3rem;
  outline: none;
  font-size: 100%;
  position: relative;
  background-color: #222;
  border-radius: 6px;

  &:hover {
    box-shadow: 0 2px 2px #0000005e;
  }
}
.keyboard button.key::before {
  content: attr(data-char);
  position: absolute;
  top: 2px;
  left: 4px;
  font-size: 0.9rem;
  color: #eee;
}
</style>
